<template>
  <div class="feedback-message-container">
    <Form
      v-slot="{ meta, errors, isSubmitting }"
      :initial-values="pick(customerInfo, ['phone', 'email'])"
      @submit="handleSubmit"
      keep-values
      class="vbox w-100 my-3 gap-12px align-items-center feedback-message"
    >
      <div class="input-group mb-1">
        <div class="input-group-text">
          {{ $t("feedback.form.fields.email.label") }}
        </div>
        <Field
          :label="$t('feedback.form.fields.email.validation.label')"
          placeholder="mail@domain.com"
          :class="
            ['form-control', 'px-10', 'flex-grow-1'].concat(
              errors.email ? ['is-invalid'] : []
            )
          "
          name="email"
          rules="required|email"
          id="email"
          type="email"
        />
      </div>
      <ErrorMessage class="invalid-feedback" name="email" />

      <Field
        :label="$t('feedback.form.fields.message.validation.label')"
        :placeholder="$t('feedback.form.fields.message.placeholder')"
        :class="
          ['form-control', 'px-10', 'flex-grow-1'].concat(
            errors.message ? ['is-invalid'] : []
          )
        "
        name="message"
        rules="required|max:10000"
        id="message"
        as="textarea"
      />
      <ErrorMessage class="invalid-feedback" name="message" />

      <button :disabled="!meta.valid || isSubmitting" class="btn-send">
        {{ $t("feedback.form.buttons.submit") }}
      </button>
      <button
        @click="$emit('cancel')"
        :disabled="isSubmitting"
        type="button"
        class="btn-dismiss"
      >
        {{ $t("feedback.form.buttons.cancel") }}
      </button>
    </Form>
  </div>
</template>
<script lang="ts">
import { Form, Field, ErrorMessage, FormActions } from "vee-validate";
import { computed } from "vue";
import _ from "lodash";
import { useStore } from "vuex";
import {
  showFailedRequestToastError,
  showToastSuccess
} from "@/helpers/notification";
import { i18n } from "@/lang";
import { useRoute } from "vue-router";

export default {
  components: { Form, Field, ErrorMessage },

  emits: ["done", "cancel"],

  setup(props: {}, context: { emit: Function }) {
    const route = useRoute();
    const store = useStore();

    const customerInfo = computed(() => store.state.metadata.customerInfo);

    return {
      customerInfo,
      handleSubmit: async (
        values: { [k: string]: string },
        actions: FormActions<any>
      ) => {
        await store
          .dispatch(
            "session/createFeedback",
            _.assign(
              {
                type: "bug-report"
              },
              values,
              JSON.parse((route.query.feedback_payload ?? "{}") as string),
              {
                // client: {
                //   extension: store.getters["auth/deviceId"]
                // }
              }
            )
          )
          .then(() => {
            actions.resetForm();
            showToastSuccess(
              i18n.global.t("feedback.form.notifications.success")
            );
            context.emit("done");
          })
          .catch(err => {
            actions.setErrors(
              (err.response?.data as { errors?: object }).errors ?? {}
            );
            showFailedRequestToastError(err);
          });
      },
      ..._.pick(_, "pick")
    };
  }
};
</script>
<style lang="scss">
.feedback-message-container {
  width: 100%;
  max-width: min(100vw, 500px);
  display: flex;
  flex-direction: column;
  gap: 10px;

  flex-grow: 1;
  flex-shrink: 1;

  background: hsla(0, 0%, 98%, 1);
  border-radius: 10px 10px 0 0;

  padding: 15px;
  /*
  
  position: fixed;
  left: 50%;
  bottom: 0;
  height: 65dvh;
  min-height: 380px;
  transform: translateX(-50%);
  */
}

.feedback-message {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  flex-grow: 1;
  flex-shrink: 1;

  justify-content: flex-start;
  align-items: stretch;

  .input-group {
    .input-group-text,
    .form-control {
      font-size: 14px !important;
    }
  }

  textarea.form-control {
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 14px !important;
  }

  .btn-send,
  .btn-dismiss {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    font-style: normal;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 500px;
    min-height: 48px;
    padding: 5px;
    font-size: 17px;
    line-height: 24px;
    text-decoration: none;
    border: none;
    border-radius: 9px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    transition: background-color 0.3s;
  }
  .btn-send {
    &:not(:disabled) {
      background: black;
      color: white;
    }
    &:disabled {
      background-color: hsla(0, 0%, 0%, 0.05);
      color: hsla(0, 0%, 30%, 0.2);
    }
  }
  .btn-dismiss {
    background-color: hsla(0, 0%, 0%, 0.1);
    &:not(:disabled) {
      color: hsla(0, 0%, 30%, 1);
      &:active {
        background-color: hsla(0, 0%, 0%, 0.2);
      }
    }
    &:disabled {
      color: hsla(0, 0%, 30%, 0.3);
    }
  }
}
</style>
